module.exports = __webpack_public_path__ + "static/icon-filter-b948e9791687f81f8c406a13a3a1c537.svg";